// Legacy-Migrationsfunktionen — Tests: src/app/migrations/migrations.spec.ts
import { AufnahmePunktDocument, CURRENT_VERSION, HorizontZeile, MoorTyp, SubstratZeile } from "./data-model";

export function updateBohrpunktV(bp: any): AufnahmePunktDocument {
	if (bp.version !== undefined && bp.version !== null) return bp;
	if (!bp.quality) {
		bp.quality = 1;
	}

	bp.Horizontfolge?.forEach((row: HorizontZeile) => {
		if (!row.maechtigkeit) row.maechtigkeit = 0;
	});

	if (bp.header.bodenform?.hauptbodenform !== undefined) {
		const hbf = bp.header.bodenform.hauptbodenform;
		const fbf = bp.header.bodenform.feinbodenform;
		bp.header.bodenform.bf = [{ hbf: hbf, fbf: fbf }];
		delete bp.header.bodenform.hauptbodenform;
		delete bp.header.bodenform.feinbodenform;
	}

	bp.version = 0;
	return bp;
}

export function updateBohrpunktV0(bp: any): AufnahmePunktDocument {
	if (bp.version !== 0) return bp;
	if (bp.extendedHeader) {
		bp.extendedHeader.geologie = bp.header.geologie; delete bp.header.geologie;
		bp.extendedHeader.morphologie = bp.header.morphologie; delete bp.header.morphologie;

		bp.header.bodenform = bp.extendedHeader.bodenform; delete bp.extendedHeader.bodenform;
		bp.header.humusform = bp.extendedHeader.humusForm; delete bp.extendedHeader.humusForm;
		bp.header.wasserstufe = bp.extendedHeader.wasserstufe; delete bp.extendedHeader.wasserstufe;
	}
	if (bp.bemerkungen !== undefined) {
		bp.header.bemerkungen = bp.bemerkungen; delete bp.bemerkungen;
	}

	bp.version = 1;
	return bp;
}

export function updateBohrpunktV1(bp: any): AufnahmePunktDocument {
	if (bp.version !== 1) return bp;
	const typeCvt = (type: string) => {
		switch (type) {
			case 'Weisergrube':
				return '1_Weisergrube_ohne_Bodenanalyse';
			case 'Bodengrube':
				return '3_Bodengrube_ohne_Bodenanalyse';
			case 'Humusprobe':
				return '5_Humusprobe';
			case 'Bohrpunkt':
				return '6_Bohrpunkt';
			case 'Moorpunkt':
				return '7_Moorpunkt';
			case 'Abgrenzbohrung':
				return '9990_Infopunkt';
			case 'Halbtiefbohrung':
				return '9998_Halbtiefbohrung';
			case 'Grenzaufschluss':
				return '9999_Grenzaufschluss';
			default:
				return type;
		}
	};
	bp.type = typeCvt(bp.type)
	bp.version = 2;
	return bp
}

export function updateBohrpunktV2(bp: any): AufnahmePunktDocument {
	if (bp.version !== 2) return bp;
	if (bp.extendedHeader) {
		bp.extendedHeader.substratfeuchte = bp.header.substratfeuchte; delete bp.header.substratfeuchte;

		bp.header.substratfeuchte = bp.extendedHeader.substratfeuchte; delete bp.extendedHeader.substratfeuchte;
	}

	bp.version = 3;
	return bp;
}

export function updateBohrpunktV3(bp: any): AufnahmePunktDocument {
	if (bp.version !== 3) return bp;
	if (bp.type === "6_Bohrpunkt")
		bp.type = "6_Tiefbohrung";

	bp.version = 4;
	return bp;
}

export function updateBohrpunktV4(bp: any): AufnahmePunktDocument {
	if (bp.version !== 4) return bp;

	if (bp.Bodenvegetationen) {
		bp.bodenvegetation = { /*bestandsBeschreibung: '', */aufnahme: { schichtAnteile: {}, vegetationen: bp.Bodenvegetationen } };
		delete bp.Bodenvegetationen;
	}

	bp.version = 5;
	return bp;
}

export function updateBohrpunktV5(bp: any): AufnahmePunktDocument {
	if (bp.version !== 5) return bp;

	// Migration: Leeres projects-Array hinzufügen
	if (!bp.header.projects) {
		bp.header.projects = [];
	}

	bp.version = 6;
	return bp;
}

export function updateBohrpunktV6(bp: any): AufnahmePunktDocument {
	if (bp.version !== 6) return bp;

	// Migration: Punktart-Umbenennungen
	// 70_Halbtiefbohrung_mit_Protokoll -> 9991_Halbtiefbohrung_mit_Protokoll
	// 9990_Abgrenzbohrung -> 9990_Infopunkt
	if (bp.type === '70_Halbtiefbohrung_mit_Protokoll') {
		bp.type = '9991_Halbtiefbohrung_mit_Protokoll';
	}
	if (bp.type === '9990_Abgrenzbohrung') {
		bp.type = '9990_Infopunkt';
	}

	bp.version = 7;
	return bp;
}

export function updateBohrpunkt(bp: any): AufnahmePunktDocument {
	if (bp.version !== CURRENT_VERSION) {
		console.error(`Bohrpunkt-Version ${bp.version} kann nicht aktualisiert werden. Erwartet: ${CURRENT_VERSION}`);
		return bp;
	}

	if (bp.extendedHeader && !bp.extendedHeader?.klimaStufe) {
		bp.extendedHeader.klimaStufe = { neu: '' };
	}

	if (bp.extendedHeader && (!bp.extendedHeader.morphologie || bp.extendedHeader.morphologie.length === 0)) {
		bp.extendedHeader.morphologie = ['', ''];
	}

	if (bp.extendedHeader && !bp.extendedHeader.baumarten) {
		bp.extendedHeader.baumarten = '';
	}

	// Substrat/Horizontfolge kürzen wenn Aufnahmetiefe < 160 (aber nicht für Moorpunkte)
	// Bei Moorpunkten ist header.aufnahme.tiefe die Moormächtigkeit, nicht die Profiltiefe
	if (bp.type !== '7_Moorpunkt' && bp.header.aufnahme.tiefe > 0 && bp.header.aufnahme.tiefe < 160) {
		const sf = bp.Substratfolge;
		const hf = bp.Horizontfolge;
		if (sf && hf) {
			const removeSf = sf.findIndex((val: SubstratZeile) => val.tiefe >= 160);
			const removeHf = hf.findIndex((val: HorizontZeile) => val.tiefe >= 160);
			if (removeSf > 0) bp.Substratfolge.splice(removeSf);
			if (removeHf > 0) bp.Horizontfolge.splice(removeHf);
		}
	}

	if (bp.checkerComments && !(bp.checkerComments instanceof Map)) {
		if (bp.checkerComments instanceof Object) bp.checkerComments = new Map<string, any>(Object.entries<any>(bp.checkerComments));
		if (bp.checkerComments.size == 0) delete bp.checkerComments;
	}

	if (bp.checkerComments) {
		const m = bp.checkerComments as Map<string, any>;
		const updateComment = (v: any) => {
			return { resolved: false, type: v.type, comments: [{ name: v.name, time: Date.now(), msg: v.msg }] };
		};
		for (const v of m) {
			if (v[1].msg !== undefined && v[1].comments === undefined) {
				m.set(v[0], updateComment(v[1]));
			}
			else if (v[1].msg === undefined && v[1].comments !== undefined) {
				if (v[1].resolved === undefined)
					v[1].resolved = false;
			}
			else {
				alert(decodeURI("Fehler bei der Konvertierung eines Bohrpunkt-Kommentars"));
			}
		}
	}

	if (bp.type === '7_Moorpunkt') {
		if (bp.extendedHeader && !bp.extendedHeader.moorTyp) {
			bp.extendedHeader.moorTyp = {} as MoorTyp;
		}
	}
	else if (bp.extendedHeader) {
			delete bp.extendedHeader.moorTyp;
	}

	// Relief-Objekt initialisieren falls nicht vorhanden
	if (bp.extendedHeader && !bp.extendedHeader.relief) {
		bp.extendedHeader.relief = {};
	}
	// Migration: torfart (string) -> torfarten (Array)
	bp.Substratfolge?.forEach((row: SubstratZeile) => {
		if (!row.torfarten) {
			const oldTorfart = (row as any).torfart;
			row.torfarten = oldTorfart ? [oldTorfart, '', ''] : ['', '', ''];
			delete (row as any).torfart;
		}
	});

	return bp;
}
